export const VALID_UPLOAD_IMAGE_SIZES = ['xs', 's', 'm', 'xl'];

export const UPLOAD_IMAGE_SIZE_SELECT_OPTIONS = [
  { value: '', label: 'Original (no server resize)' },
  { value: 'xs', label: 'XS — max width 96 px' },
  { value: 's', label: 'S — max width 320 px' },
  { value: 'm', label: 'M — max width 800 px' },
  { value: 'xl', label: 'XL — max width 1920 px' },
];

export function normalizeUploadImageSize(value) {
  const s = String(value ?? '').trim().toLowerCase();
  return VALID_UPLOAD_IMAGE_SIZES.includes(s) ? s : null;
}

export function uploadSizeQueryParams(size) {
  const s = normalizeUploadImageSize(size);
  return s ? { size: s } : {};
}
